//Created by Matthew van der Haas (matt@vdhdesign.co.nz)
class UtilsMath
{
    isPointWithinBounds(_pointX,_pointY,_boundsX,_boundsY,_width,_height)
    {
        return _pointX >=_boundsX && _pointX <= _boundsX+_width && _pointY >=_boundsY && _pointY <= _boundsY+_height;
    }
        
    getDistanceSquaredBetween2dPoints(_fX0, _fY0,_fX1, _fY1)
    {
        var fResultX = Math.pow((_fX1 - _fX0), 2.0);
        var fResultY = Math.pow((_fY1 - _fY0), 2.0);
        var fResult = fResultX + fResultY;
        return fResult;	
    }


    getDistanceBetween2dPoints(_point1,_point2)
    {
        var fResultX = Math.pow((_point2.x - _point1.x), 2.0);
        var fResultY = Math.pow((_point2.y - _point1.y), 2.0);
        var fResult = Math.sqrt(fResultX + fResultY);
        return fResult;

    }

    polarToCartesianX(_fPolarRadius, _fPolarAngle, _bInDegrees = true)
    {
        if(_bInDegrees)
        {
            _fPolarAngle = this.degreesToRadians(_fPolarAngle);
        }

        var fCartesianX = _fPolarRadius * Math.cos(_fPolarAngle);
        return fCartesianX;
    }

    polarToCartesianY(_fPolarRadius, _fPolarAngle, _bInDegrees = true)
    {
        if(_bInDegrees)
        {
            _fPolarAngle = this.degreesToRadians(_fPolarAngle);
        }

        var fCartesianY = _fPolarRadius * Math.sin(_fPolarAngle);
        return fCartesianY;
    }

    cartesianToPolarAngle(_fCartesianX, _fCartesianY, _bInDegrees = true)
    {
        var polarAngle = Math.atan(_fCartesianY/_fCartesianX);

        polarAngle += this.returnRadianValueToAdd(_fCartesianX,_fCartesianY);

        if(_bInDegrees)
        {
            polarAngle = this.radianToDegrees(polarAngle);
        }
        return polarAngle;
    }

    getPerpendicularCartesianX(_fPolarRadius, _fPolarAngle, _bInDegrees)
    {
        //todo fix for radians
        if(_bInDegrees)
        {
            _fPolarAngle -= 90;
            
            if(_fPolarAngle < 0)
            {
                _fPolarAngle += 360;
            }
        }
        //in radians
        else
        {
            _fPolarAngle -= Math.PI/2;
            
            if(_fPolarAngle < 0)
            {
                _fPolarAngle += Math.PI*2;
            }
        }

        return this.polarToCartesianX(_fPolarRadius,_fPolarAngle,_bInDegrees);

    }


    getPerpendicularCartesianY(_fPolarRadius, _fPolarAngle, _bInDegrees)
    {
        //todo fix for radians
        if(_bInDegrees)
        {
            _fPolarAngle -= 90;
            
            if(_fPolarAngle < 0)
            {
                _fPolarAngle += 360;
            }
        }
        //in radians
        else
        {
            _fPolarAngle -= Math.PI/2;
            
            if(_fPolarAngle < 0)
            {
                _fPolarAngle += Math.PI*2;
            }
        }
        return this.polarToCartesianY(_fPolarRadius,_fPolarAngle,_bInDegrees);
    }


    returnRadianValueToAdd(_fCartesianX, _fCartesianY)
    {
        var iQuadrant = this.getQuadrant(_fCartesianX, _fCartesianY);
        if(iQuadrant == 1)
        {
            return 0;
        }
        else if(iQuadrant == 2 || iQuadrant == 3)
        {
            return Math.PI;
        }
        else
        {
            return Math.PI*2;
        }
    }


    getQuadrant(_fCartesianX, _fCartesianY)
    {

        if( _fCartesianX >= 0 && _fCartesianY >= 0)
        {
            return 1;
        }
        else if(_fCartesianX < 0 && _fCartesianY >= 0)
        {
            return 2;
        }
        else if(_fCartesianX < 0 && _fCartesianY < 0)
        {
            return 3;
        }
        else
        {
            return 4;
        }
    }


    radianToDegrees(_fRadian)
    {
        var fInDegrees = (_fRadian/Math.PI)*180;
        return fInDegrees;
    }


    degreesToRadians(_fDegrees)
    {
        var fInRadians = (_fDegrees/180)*Math.PI;
        return fInRadians;
    }


    getRandomBool()
    {
        var randomNum = this.getRandomNumber(1,50);
        var randomBool = (randomNum % 2 == 0);
        return randomBool;
    }

    /**
     * Returns a random number between min and max
     */
    //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random?redirectlocale=en-US&redirectslug=JavaScript%2FReference%2FGlobal_Objects%2FMath%2Frandom
    getRandomNumber(min, max)
    {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    getDifference(_fXFrom, _fXTo)
    {
        var fDifference = _fXTo - _fXFrom;
        return fDifference;
    }
}

export default (new UtilsMath());




/** WEBPACK FOOTER **
 ** ./lib/utils-math.js
 **/